import type { ClassTaxonomyNode, RelationshipTaxonomyNode } from '@semantical/modules/ontology-model';

/**
 * Find a class node in the taxonomy by URI (recursive).
 */
export function findClassNodeByUri(
    nodes: ClassTaxonomyNode[],
    uri: string
): ClassTaxonomyNode | undefined {
    for (const node of nodes) {
        if (node.uri === uri) return node;
        if (node.children) {
            const found = findClassNodeByUri(node.children, uri);
            if (found) return found;
        }
    }
    return undefined;
}

/**
 * Find a relationship node in the taxonomy by URI (recursive).
 */
export function findRelationshipNodeByUri(
    nodes: RelationshipTaxonomyNode[],
    uri: string
): RelationshipTaxonomyNode | undefined {
    for (const node of nodes) {
        if (node.uri === uri) return node;
        if (node.children) {
            const found = findRelationshipNodeByUri(node.children, uri);
            if (found) return found;
        }
    }
    return undefined;
}

/**
 * Get a class label by URI from the loaded class taxonomy.
 */
export function getClassLabelFromTaxonomy(
    taxonomy: ClassTaxonomyNode[] | null,
    uri: string
): string | undefined {
    if (!taxonomy) return undefined;
    const node = findClassNodeByUri(taxonomy, uri);
    return node?.label;
}
